import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";
import { OAuthApplication } from "../../auth";

interface IProps {
  primaryOrganization?: string;
  count?: number;
  includePrimaryOrg?: boolean;
  includeParticipatingOrg?: boolean;
}

export async function GetOrganizationAffiliation({
  primaryOrganization,
  count,
  includePrimaryOrg,
  includeParticipatingOrg,
}: IProps) {
  // Construir URL base
  let url = `${endpoints.ADMFHIR}/OrganizationAffiliation`;

  // Construir parâmetros de query apenas se não for busca por ID específico
  const queryParams: string[] = [];

  // Adicionar parâmetros válidos ao array
  if (count) queryParams.push(`_count=${count}`);

  if (primaryOrganization)
    queryParams.push(
      `primary-organization=${encodeURIComponent(primaryOrganization)}`
    );

  // Adicionar parâmetros de inclusão
  if (includePrimaryOrg) {
    queryParams.push("_include=OrganizationAffiliation:primary-organization");
  }

  if (includeParticipatingOrg) {
    queryParams.push(
      "_include=OrganizationAffiliation:participating-organization"
    );
  }

  // Concatenar parâmetros com '&' se houver algum
  if (queryParams.length > 0) {
    url = `${url}?${queryParams.join("&")}`;
  }
  const headers = {
    Accept: "*/*",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };
  const response = await useAxios
    .get(url, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`GetOrganizationAffiliation: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("GetOrganizationAffiliation ", error);
      // toast.error(`GetOrganizationAffiliation Error: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
